module.exports = __webpack_public_path__ + "img/653.3f1fa830.png";